export default __webpack_public_path__ + "strongher-devices_tablet.a6152a80.png";